module.exports = __webpack_public_path__ + "media/images/lp/lp26-e99ff7c1ed3de5bba37db6c8eb686b78.webp";